<template>
  <a-modal
    :visible="visible"
    :title="$t('attach_table_dir_rename')"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :maskClosable="false"
    :confirmLoading="loading"
    centered
    destroyOnClose
  >
    <a-form-model
      ref="renameForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-form-model-item :label="$t('attach_form_folder_name')" prop="name">
        <a-input v-model="formData.name" :placeholder="$t('attach_form_folder_name_placeholder')" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { renameDirectory } from '@/api/attach';

export default {
  name: 'RenameDialog',
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        id: '',
        name: '',
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t('attach_form_folder_name_placeholder'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    show(record) {
      this.visible = true;
      this.formData = {
        id: record.id,
        name: record.name,
      };
    },
    handleCancel() {
      this.visible = false;
      this.resetForm();
    },
    async handleSubmit() {
      try {
        this.$refs.renameForm.validate(async valid => {
          if (valid) {
            this.loading = true;
            await renameDirectory(this.formData);
            this.$message.success(this.$t('attach_rename_success'));
            this.$emit('success');
            this.handleCancel();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.$refs.renameForm.resetFields();
      this.formData = {
        id: '',
        name: '',
      };
    },
  },
};
</script>
